/**
 * Ajax autohandler.
 *
 * Usage:
 *
 *  data-sw-ajax-link
 *
 *    On an anchor tag with href set, this will ajax to the url instead of navigating to it
 *    will generate a noty to show success or failure
 *    data-sw-ajax-link
 *
 *  data-sw-ajax-form
 *    TODO: This functionality should be integrated into ShapewaysFormView https://jira.shapeways.net/browse/SW-30754
 *
 *    Will submit a form via ajax using all of its params and data.
 *
 *  data-sw-ajax-form-file
 *    TODO: This functionality should be integrated into ShapewaysFormView https://jira.shapeways.net/browse/SW-30754
 *
 *    Will submit a form that has a file input, and handle accordingly. Validates size, and specifies a target to update
 *    if an image url is found in the response.
 *
 *    data-sw-ajax-form-file-size-limit=<string number in bytes>
 *    data-sw-ajax-form-file-preview-target-selector=<string file target used when uploading an image (sets the background)>
 */

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var _ = require('underscore');

var defaultSuccess = "Success";
var defaultErrorResponse = "Oops, we messed up. We'll try again later.";
var defaultFormSuccess = "Form submitted successfully!";

var waitingClass = 'waiting';

/**
 * Validates files coming from an input to make sure they're under a designated limit.
 * @param files
 * @param sizeLimit
 * @returns {boolean}
 */
function validateFileSize(files, sizeLimit) {
  var validated = true;

  var userFriendlySize = sizeLimit + 'kb';
  if (sizeLimit > 1000000) {
    userFriendlySize = sizeLimit/1000/1000 + 'mb';
  }
  _.each(files, function(file) {
    if (file.size > sizeLimit) {
      sw.notifications.error('File is too large! File must be under ' + userFriendlySize + '.');
      validated = false;
    }
  });

  return validated;
}

$(document).ready(function() {
  $('body').on('click', '[data-sw-ajax-link]', function(e) {
    e.preventDefault();
    var $el = $(this);
    var $submitButton = $el.find('[data-sw-submit-button]');
    $submitButton.addClass(waitingClass);
    var $elToHide = $('body').find($el.attr('data-sw-ajax-hide-on-sucess'));
    $.ajax({
      type:'POST',
      url: $el.attr('href'),
      dataType: 'json',
      success: function(response) {
        $submitButton.removeClass(waitingClass);
        $elToHide.hide();
        var message = response && response.data && response.data.message ? response.data.message : defaultSuccess;
        sw.notifications.displayNoty(message, {type: 'success'});
      },
      error: function(response) {
        $submitButton.removeClass(waitingClass);
        var message = response && response.data && response.data.message ? response.data.message : defaultErrorResponse;
        sw.notifications.displayNoty(message, {type: 'error'});
      }
    });
  });

  $('body').on('submit', '[data-sw-ajax-form]', function(e) {
    var $el = $(e.currentTarget);

    var data = $el.serialize();
    var $submitButton = $el.find('[data-sw-submit-button]');
    $submitButton.addClass(waitingClass);

    $.ajax({
      type: $el.attr('method'),
      url:  $el.attr('action'),
      data: data,
      dataType: 'json',
      success: function(response) {
        $submitButton.removeClass(waitingClass);
        var message = response && response.data && response.data.message ? response.data.message : defaultFormSuccess;
        sw.notifications.success(message);
      },
      error: function(jqXhr) {
          try {
              var response = window.JSON.parse(jqXhr.responseText);
              var failedMessage = response && response.data && response.data.message ? response.data.message : defaultErrorResponse;
              $submitButton.removeClass(waitingClass);
              sw.notifications.error(failedMessage);
          } catch(e) {
              throw e;
          }
      }
    });

    return false;
  });

  $('body').on('submit', '[data-sw-ajax-form-file]', function(e) {
    e.preventDefault();

    var $el = $(e.currentTarget);

    var previewTargetSelector = $el.data('swAjaxFormFileTarget');
    var sizeLimit = $el.data('swAjaxFormFileSizeLimit');
    var successEvent = $el.data('swAjaxFormFileSuccessEvent');

    var fileInputs = $(this).find('input[type=file]');

    var validFileSize = true;

    // Validate each file input submitted to check size.
    if (fileInputs[0] && sizeLimit) {
      var sizeLimitBytes = sizeLimit * 1000;
      _.each(fileInputs, function(fileInput) {
        if (!validateFileSize(fileInput.files, sizeLimitBytes)) {
          validFileSize = false;
        }
      });
    }

    if (!validFileSize) {
      return false;
    }

    var formData = new FormData($(this)[0]);

    $.ajax({
      type: $el.attr('method'),
      url:  $el.attr('action'),
      data: formData,
      dataType: 'json',
      contentType: false,
      processData: false,
      success: function(response) {
        // Trigger success noty
        var message = response && response.message ? response.message : defaultFormSuccess;
        sw.notifications.success(message);

        // Update background image with provided URL
        if (!_.isUndefined(response.imageUrl) && previewTargetSelector) {
          $(previewTargetSelector).css('background-image', 'url(' + response.imageUrl + ')');
        }

        // Triggers an event on success
        if (successEvent) {
          sw.trigger(successEvent);
        }
      },
      error: function(jqXhr) {
          try {
              var response = window.JSON.parse(jqXhr.responseText);
              var failedMessage = response && response.message ? response.message : defaultErrorResponse;
              sw.notifications.error(failedMessage);
          } catch(e) {
              throw e;
          }
      }
    });

    return false;
  });
});
